module.exports = __webpack_public_path__ + "img/678CBAE8.898e9e22.png";